// extracted by mini-css-extract-plugin
export var dividerLine = "_4z-0";
export var errorBackground = "_4z-1";